import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { MY_OFFERS_LISTING_KEY } from '@steelbuy/data-access';
import { CheckoutContextProvider } from '../../components/checkout/CheckoutContext';
import { MyOffersContextProvider } from '../../components/my-offers/MyOffersContext';

export const MyOffersView = () => {
    const queryClient = useQueryClient();

    useEffect(
        () => () => {
            queryClient.removeQueries({ queryKey: [MY_OFFERS_LISTING_KEY] });
        },
        []
    );

    return (
        <MyOffersContextProvider>
            <CheckoutContextProvider>
                <Outlet />
            </CheckoutContextProvider>
        </MyOffersContextProvider>
    );
};
